import { useLocale } from '@dreamstack/i18n'
import { propertiesOverviewOtherLocaleUrls } from './getPropertyUrl'

export const usePropertyOverviewUrl = () => {
  const locale = useLocale()
  return propertiesOverviewOtherLocaleUrls[locale].url
}
